<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { initializeFCM } from './firebase/messaging';
import GlobalLoader from './components/common/GlobalLoader.vue';
import Navbar from './components/common/Navbar.vue';
import { useAuthStore } from './stores/auth.store';
import { storeToRefs } from 'pinia';

const route = useRoute();
const authStore = useAuthStore();
const { isAuthReady } = storeToRefs(authStore);

const authReady = computed(() => isAuthReady.value);

initializeFCM();
</script>

<template>
	<div class="w-screen h-screen flex flex-col items-stretch justify-stretch relative">
		<div v-if="!authReady" class="flex-1 flex items-center justify-center">
			<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
		</div>

		<template v-else>
			<Navbar v-if="!route.meta.hideNavbar" />
			<RouterView />
			<GlobalLoader />
		</template>
	</div>
</template>
